<template>

    <div class="list">

        <div class="list__tr"
             :class="{'list__tr__padding': !searching}"
             v-show="isDesktop && list.length">

            <div class="list__tr__cell list__tr__1 pointer" @click="toggleAll">
                <img
                    :src="allChecked ? '/img/newsletters-v2/checkbox-on.svg' : '/img/newsletters-v2/checkbox-off.svg'"
                    class="img__20">
            </div>
            <div class="list__tr__cell list__tr__2">
                <p class="text-lSemibold color__moon">{{ $t('cleaning_sender') }}</p>
            </div>
            <div class="list__tr__cell list__tr__2">
                <p class="text-lSemibold color__moon">{{ $t('cleaning_sender_address') }}</p>
            </div>
            <div class="list__tr__cell list__tr__2 pointer" @click="sortByCount">
                <p class="text-lSemibold"
                   :class="{
                    'color__moon': !sortedByCount,
                    'color__aquamarine': sortedByCount
                }">{{ $tc('cleaning_cards_received_emails', 2) }}</p>
                <img :src="`/img/newsletters-v2/chevron-down-full-${sortedByCount ? 'blue': 'grey'}.svg`"
                     class="img__24"
                     :class="{'list__tr__img-reverse': newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING}">
            </div>
            <div class="list__tr__cell list__tr__2 pointer" @click="sortByOpenRate">
                <p class="text-lSemibold"
                   :class="{
                    'color__moon': !sortedByOpenRate,
                    'color__aquamarine': sortedByOpenRate
                }">{{ $t('cleaning_sort_open_rate') }}</p>
                <img :src="`/img/newsletters-v2/chevron-down-full-${sortedByOpenRate ? 'blue': 'grey'}.svg`"
                     :class="{'list__tr__img-reverse': newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN}"
                     class="img__24">
            </div>
            <div class="list__tr__cell list__tr__1"></div>


        </div>

        <div class="list__scroll">
            <div v-if="!isDesktop">
                <div class="list__item"
                    :class="{'list__item__active': item.checked}"
                    v-for="(item, index) in localList"
                    :key="index"
                    @click="toggleItem(index)">

                    <div class="list__item__left">
                        <img
                            :src="item.checked ? '/img/newsletters-v2/checkbox-on.svg' : '/img/newsletters-v2/checkbox-off.svg'"
                            class="img__20">
                    </div>

                    <div class="list__item__middle">
                        <p>
                            <span class="mr__4 text-xlSemibold-2">{{ item.name }} </span>
                            <span class="spoum-badge" v-show="Subscription.isSpoum(item)">{{ $t('spam') }}</span>
                        </p>
                        <p class="ellipsis-text">{{ item.sender }}</p>
                    </div>
                    <div class="list__item__right">
                        <div class="list__item__right__row">
                            <img src="/img/newsletters-v2/mail-blue.svg" class="img__24 mr__8">
                            <p>{{ item.count }}</p>
                        </div>
                        <div class="list__item__right__row">
                            <img src="/img/newsletters-v2/mail-open-blue.svg" class="img__24 mr__8">
                            <p>{{ item.openRate }} %</p>
                        </div>
                    </div>

                </div>
            </div>

            <div v-else>
                <div class="list__td pointer"
                    :class="{'list__item__active': item.checked}"
                    v-for="(item, index) in localList"
                    :key="index"
                    @click="toggleItem(index)">

                    <div class="list__td__cell list__td__1 pointer">
                        <img
                            :src="item.checked ? '/img/newsletters-v2/checkbox-on.svg' : '/img/newsletters-v2/checkbox-off.svg'"
                            class="img__20">
                    </div>
                    <div class="list__td__cell list__td__2">
                        <p class="ellipsis-text text-xlSemibold-2">{{ item.name }}
                            <span class="spoum-badge" v-show="Subscription.isSpoum(item)">{{ $t('spam') }}</span>
                        </p>
                    </div>
                    <div class="list__td__cell list__td__2">
                        <p class="ellipsis-text text-lMedium">{{ item.sender }}</p>
                    </div>
                    <div class="list__td__cell list__td__2">
                        <img src="/img/newsletters-v2/mail-blue.svg" class="img__24 mr__8">
                        <p class="text-lMedium">{{ item.count }}</p>
                    </div>
                    <div class="list__td__cell list__td__2">
                        <img src="/img/newsletters-v2/mail-open-blue.svg" class="img__24 mr__8">
                        <p class="text-lMedium">{{ item.openRate }} %</p>
                    </div>
                    <div class="list__td__cell list__td__1"></div>
                </div>
            </div>
        </div>

        <empty-spoum-area :subscriptions="list" :category="category"></empty-spoum-area>

        <actions-bar v-show="itemSelected"
                     :isList="true"
                     @action="action"></actions-bar>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

import Subscription from '@/helpers/subscription'

import ActionsBar from '@/components/newsletters-v2/ActionsBar'
import EmptySpoumArea from '@/components/newsletters-v2/EmptySpoumArea'
import Checkbox from '@/components/inputs/Checkbox'

export default {

    name: 'list',

    components: {
        ActionsBar,
        EmptySpoumArea,
        Checkbox
    },

    props: {
        list: {
            type: Array,
            default: () => []
        },

        searchValue: {
            type: String,
            default: ''
        },

        searching: {
            type: Boolean,
            default: false
        },

        category: {
            type: String,
            default: ''
        }
    },

    watch: {
        list() {
            this.initdata()
        },

        countChecked(newValue) {
            this.updateCountSelectedNewsletters(newValue)
        },

        unselectedAllNewsletters() {
            this.toggleUnselectAll()
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'unselectedAllNewsletters',
            'newslettersSort'
        ]),

        ENUM() {
            return ENUM
        },

        Subscription() {
            return Subscription
        },

        itemSelected() {
            return this.localList.filter(item => item.checked).length > 0
        },

        allChecked() {
            return this.localList.length && this.localList.length === this.countChecked
        },

        countChecked() {
            return (this.localList.length && this.localList.filter(item => item.checked).length) || 0
        },

        sortedByCount() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.ASCENDING || this.newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING
        },

        sortedByOpenRate() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.MOST_OPEN || this.newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN
        }

    },

    data() {
        return {
            localList: []
        }
    },

    mounted() {
        this.initdata()
    },

    methods: {

        ...Vuex.mapActions([
            'updateCountSelectedNewsletters',
            'updateNewslettersSort'
        ]),

        initdata() {
            this.localList = this.list
                .filter(item => item.type === ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS)
                .map(item => {
                    return {...item, checked: false}
                })
        },

        toggleItem(index) {
            this.localList[index].checked = !this.localList[index].checked
        },

        action(enumAction) {
            const senders = this.localList
                .filter(item => item.checked)
            this.$emit('action', {enumAction, senders})
        },

        toggleAll() {
            this.allChecked
                ? this.toggleUnselectAll()
                : this.toggleSelectAll()
        },

        toggleSelectAll() {
            Tag.clickGA(this, 'select_all')
            this.localList.forEach(item => item.checked = true)
        },

        toggleUnselectAll() {
            this.localList.forEach(item => item.checked = false)
        },

        sortByCount() {
            const sortBy = this.newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING
                ? ENUM.NEWSLETTERS.SORT.ASCENDING
                : ENUM.NEWSLETTERS.SORT.DESCENDING
            this.updateNewslettersSort(sortBy)
        },

        sortByOpenRate() {
            const sortBy = this.newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN
                ? ENUM.NEWSLETTERS.SORT.MOST_OPEN
                : ENUM.NEWSLETTERS.SORT.LEAST_OPEN
            this.updateNewslettersSort(sortBy)
        }
    }
}
</script>

<style lang="scss" scoped>

@import "@/style/spoum.scss";

.list {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    flex-grow: 1;
    align-items: center;

    &__tr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: stretch;
        background-color: $timberwolf;
        border-bottom: 1px solid $divider;
        @media screen and (min-width: $above-book-length) {
            background-color: $white;
        }

        &__padding {
            @media screen and (min-width: $above-book-length) {
                padding-top: 64px;
            }
        }

        &__img-reverse {
            transform: rotate(180deg);
        }

        &__cell {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            text-align: left;
            padding: 16px;
        }

        &__1 {
            display: flex;
            width: 10%
        }

        &__2 {
            width: 20%;
        }
    }

    &__scroll {
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: scroll;
    }

    &__td {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: stretch;
        background-color: $white;
        border-bottom: 1px solid $divider;

        &__cell {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            text-align: left;
            padding: 32px 16px;
        }

        &__1 {
            display: flex;
            width: 10%
        }

        &__2 {
            width: 20%;
        }
    }

    &__item {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: solid 1px #e7e7e8;
        margin-bottom: 1px;
        background-color: $white;

        &__active {
            background-color: #e0f1fc;
            @media screen and (min-width: $above-tablet-length) {
                background-color: #f7fbfe;
            }
        }

        &__left {
            width: 52px;
            padding: 16px;
        }

        &__middle {
            display: flex;
            flex: 1;
            flex-direction: column;
            text-align: left;
            overflow: hidden;
        }

        &__right {
            width: 104px;
            padding: 16px;

            &__row {
                display: flex;
                flex-direction: row;
                white-space: nowrap;
                align-items: center;
            }
        }
    }

}

</style>
